import React from "react";
import './detailViewSubtitle.less';

const DetailViewSubtitle = props => <div className='detail-view-subtitle'>{props.children}</div>;

export default DetailViewSubtitle;



// WEBPACK FOOTER //
// ./src/react/views/detailView/DetailViewSubtitle.jsx